import { createApp } from 'vue';
import App from './App.vue';
import VueCookies from 'vue-cookies';
import router from '../router';
import 'tailwindcss/tailwind.css';
import Notifications from '@kyvg/vue3-notification';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowRightFromBracket, faArrowUp, faEnvelope, faStar, faPenToSquare, faFloppyDisk, faMapLocationDot, faTrash, faDownload, faCheck, faFilePdf,
        faCreditCard, faAddressCard, faTruckMoving, faMotorcycle, faCarSide, faAngleLeft, faAngleRight, faAnglesLeft, faAnglesRight, faRotateLeft, faXmark } from '@fortawesome/free-solid-svg-icons';
import { faStar as fasStar } from '@fortawesome/free-regular-svg-icons';
import { LoadingPlugin } from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import axios from 'axios';
import { mainStore } from './../store/main';

library.add(faArrowRightFromBracket, faArrowUp, faEnvelope, faStar, fasStar, faPenToSquare, faFloppyDisk, faMapLocationDot, faTrash, faDownload, faCheck, faFilePdf,
        faCreditCard, faAddressCard, faTruckMoving, faMotorcycle, faCarSide, faAngleLeft, faAngleRight, faAnglesLeft, faAnglesRight, faRotateLeft, faXmark);

const app = createApp(App);
app.use(router);
app.use(Notifications);
app.use(VueCookies);
app.use(LoadingPlugin, { color: "#e96932", backgroundColor: "#000", height: 100, width: 100 });
app.component('font-awesome-icon', FontAwesomeIcon);
app.mount('#app');

app.config.globalProperties.$axios = axios;
axios.interceptors.request.use((config) => {
        if(mainStore.isForecast) {
                if (mainStore.access_token_forecast && !config?.url?.includes("logout")) {
                        config.headers.Authorization = `Bearer ${mainStore.access_token_forecast}`
                }  
        } else {
                if (mainStore.access_token && !config?.url?.includes("logout")) {
                        config.headers.Authorization = `Bearer ${mainStore.access_token}`
                }        
        }
        return config;
})

axios.interceptors.response.use((response) => {
        return response;
}, async (error) => { 
        console.log(error)
        /*if((error?.response?.status === 401 || error?.code === "ERR_NETWORK" ) && !error?.config?.url?.includes("openid-connect")) { //|| !error?.response
                //await axios.post(`${process.env.VUE_APP_HOST}/auth/realms/${process.env.VUE_APP_REALM}/protocol/openid-connect/logout`, {
                await axios.post(`https://test-webservice.motornet.it/auth/realms/${process.env.VUE_APP_REALM}/protocol/openid-connect/logout`, {
                        client_id: process.env.VUE_APP_CLIENT_ID,
                        refresh_token: mainStore.refresh_token
                }, { headers: { "content-type": "application/x-www-form-urlencoded" } });

                VueCookies.remove("token");
                VueCookies.remove("refreshToken");
                mainStore.access_token = null;
                mainStore.refresh_token = null;
                router.push("/");
        }*/
        return Promise.reject(error);
})
